import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl } from 'react-intl';

import { bindAll } from '@bibliocommons/utils-react';
import Checkbox from '@bibliocommons/deprecated-base-checkbox';

export class SingleBranchStatusField extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleToggleFilter() {
    this.props.handleToggleFilter(this.props.fieldId, this.props.filter);
  }

  render() {
    const { filter, label } = this.props;
    const value = filter.get('value');

    let classString = 'filter';
    if (filter.get('applied')) {
      classString += ' applied';
    }
    const formattedLabel = this.props.intl.formatMessage({ id: label });

    return (
      <div key={`${this.props.fieldId}-${value}`} className={classString}>
        <Checkbox
          id={`field-${value}`}
          handleChange={this.handleToggleFilter}
          checked={filter.get('applied')}
          label={formattedLabel}
        />
      </div>
    );
  }
}

SingleBranchStatusField.propTypes = {
  filter: ImmutablePropTypes.map,
  label: PropTypes.string.isRequired,

  handleToggleFilter: PropTypes.func,
  fieldId: PropTypes.string
};

export default injectIntl(SingleBranchStatusField);
